import React, { Component } from "react";
import $, { data } from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import DataTable from "react-data-table-component";
import ManageTabSettings from "./ManageTabSettings";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { tokenVerification } from "./Utils";
import { Link } from "react-router-dom";

class PatientRiskStatus extends Component {
  constructor() {
    super();
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1); // Yesterday
    const pastTenDays = new Date();
    pastTenDays.setDate(pastTenDays.getDate() - 10);
    const today = new Date();
    this.state = {
      selectedHospitalId: "",
      selectedHealthSystemId: "",
      selectedTreatmentId: "",
      showLoader: false,
      showQrCode: false,
      showPatientDetailsPopUp: false,
      healthSystemId: "",
      hospitalId: "",
      serviceLineId: "",
      selectedTreatmentDate: "",
      isActive: "schedule",
      selectedServiceLineId: "",
      data: [],
      hideTextAreaPopup: false,
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,
      qrCode: "",
      paginationValue: 10,
      healthSystemGroupValue: [],
      hospitalGroupValue: [],
      fromDate: pastTenDays,
      toDate: today,
      activePatients: "",
      lowRiskPatients: "",
      mediumRiskPatients: "",
      highRiskPatients: "",
      riskOverView: [],
      serviceLineGroupValue: [],
      isLoading: true,
      searchTerm: "",
      tilesFilteredData: [],
      enteredLastNDays: "",
      searchIcon: true,
      noMatchingData: false,
      lastNDaysData: {},
      debounceTimeout: null,
      lastNDaysDebounceTimeout: null,
      riskData: [],
      tilesFilteredriskData: [],
      selectedFilter: "",
      allPhysicians: [],
      physicianId: "",
      selectedPhysicianId: "",
      tableReady: false,
    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.procedureVar = [];
    this.serviceLineVar = [];
    this.physicianVar = [];
    this.proceduresByServiceLine = [];
    this.physiciansByServiceLine = [];

    this.state.selectedHealthSystemId = localStorage.getItem("healthSystemId");
    this.state.selectedHospitalId = localStorage.getItem("hospitalId");
    this.state.selectedServiceLineId = localStorage.getItem("serviceLineId");
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    this.healthSystemDropDownInMARef = React.createRef();
    this.hospitalDropDownInMARef = React.createRef();
    this.seriviceLineDropDownInMARef = React.createRef();

  }
  componentDidMount() {
    var thisController = this;
    const savedPage = localStorage.getItem("lastDashBoardActivePage");
    if (savedPage !== null) {
      thisController.restoredPage = parseInt(savedPage);
      localStorage.removeItem("lastDashBoardActivePage");
    } else {
      thisController.restoredPage = 1;
    }

    if (thisController.userDetails.userRole === "PHYSICIAN") {
      thisController.fetchAllPhysicians();
      var lastUsedDropdown = localStorage.getItem("last-used-dropdown");
      if (lastUsedDropdown === "mine") {
        thisController.state.selectedHealthSystemId =
          localStorage.getItem("healthSystemId");
        thisController.state.selectedHospitalId =
          localStorage.getItem("hospitalId");
        localStorage.setItem("admissions-nav-bar-selection", "manage-admission");

        var userRole = thisController.userDetails["userRole"];
        if (userRole == "HEALTHSYSTEM_ADMIN") {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
        } else if (
          userRole == "HOSPITAL_ADMIN"
        ) {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
        } else if (
          userRole == "SERVICELINE_ADMIN" ||
          userRole == "PHYSICIAN"
        ) {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
          thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
        } else {
          thisController.state.selectedHealthSystemId =
            localStorage.getItem("healthSystemId");
          thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
        }
        thisController.setState(thisController.state);
        thisController.fetchHealthSystemDetails();
        var thisController = this;
        var serviceLinesLoadedPromise = thisController.fetchServiceLines();
        var fetchLastNDaysPromise = thisController.fetchLastNDays();
        var proceduresLoadedPromise = thisController.fetchProcedures();
        var physicianLoadPromise = thisController.fetchPhysicians();
        Promise.all([
          serviceLinesLoadedPromise,
          fetchLastNDaysPromise,
          proceduresLoadedPromise,
          physicianLoadPromise,
        ]).then(() => {
          // thisController.fetchManageAdmissionDetails();
          thisController.fetchRiskAdmissions();
          thisController.setState(thisController.state);
        });
        this.onActiveClick = this.onActiveClick.bind(this);
      } else if (lastUsedDropdown === "myHospital") {
        thisController.state.selectedHealthSystemId =
          localStorage.getItem("healthSystemId");
        thisController.state.selectedHospitalId =
          localStorage.getItem("hospitalId");
        localStorage.setItem("admissions-nav-bar-selection", "manage-admission");

        var userRole = thisController.userDetails["userRole"];
        if (userRole == "HEALTHSYSTEM_ADMIN") {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
        } else if (
          userRole == "HOSPITAL_ADMIN"
        ) {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
        } else if (
          userRole == "SERVICELINE_ADMIN" ||
          userRole == "PHYSICIAN"
        ) {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
          thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
        } else {
          thisController.state.selectedHealthSystemId =
            localStorage.getItem("healthSystemId");
          thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
        }
        thisController.setState(thisController.state);
        // thisController.fetchHealthSystemDetails();
        var thisController = this;
        var serviceLinesLoadedPromise = thisController.fetchServiceLines();
        var fetchLastNDaysPromise = thisController.fetchLastNDays();
        var proceduresLoadedPromise = thisController.fetchProcedures();
        var physicianLoadPromise = thisController.fetchPhysicians();
        Promise.all([
          serviceLinesLoadedPromise,
          fetchLastNDaysPromise,
          proceduresLoadedPromise,
          physicianLoadPromise,
        ]).then(() => {
          // thisController.fetchManageAdmissionDetails();
          thisController.fetchRiskAdmissionsForHospital();
          thisController.setState(thisController.state);
        });
      } else if (lastUsedDropdown === "myDepartment") {
        thisController.state.selectedHealthSystemId =
          localStorage.getItem("healthSystemId");
        thisController.state.selectedHospitalId =
          localStorage.getItem("hospitalId");
        localStorage.setItem("admissions-nav-bar-selection", "manage-admission");

        var userRole = thisController.userDetails["userRole"];
        if (userRole == "HEALTHSYSTEM_ADMIN") {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
        } else if (
          userRole == "HOSPITAL_ADMIN"
        ) {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
        } else if (
          userRole == "SERVICELINE_ADMIN" ||
          userRole == "PHYSICIAN"
        ) {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
          thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
        } else {
          thisController.state.selectedHealthSystemId =
            localStorage.getItem("healthSystemId");
          thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
        }
        thisController.setState(thisController.state);
        // thisController.fetchHealthSystemDetails();
        var thisController = this;
        var serviceLinesLoadedPromise = thisController.fetchServiceLines();
        var fetchLastNDaysPromise = thisController.fetchLastNDays();
        var proceduresLoadedPromise = thisController.fetchProcedures();
        var physicianLoadPromise = thisController.fetchPhysicians();
        Promise.all([
          serviceLinesLoadedPromise,
          fetchLastNDaysPromise,
          proceduresLoadedPromise,
          physicianLoadPromise,
        ]).then(() => {
          // thisController.fetchManageAdmissionDetails();
          // thisController.fetchRiskAdmissions();
          thisController.fetchRiskAdmissionsForServiceLine();
          thisController.setState(thisController.state);
        });
      } else if (lastUsedDropdown === null) {
        thisController.state.selectedHealthSystemId =
          localStorage.getItem("healthSystemId");
        thisController.state.selectedHospitalId =
          localStorage.getItem("hospitalId");
        localStorage.setItem("admissions-nav-bar-selection", "manage-admission");

        var userRole = thisController.userDetails["userRole"];
        if (userRole == "HEALTHSYSTEM_ADMIN") {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
        } else if (
          userRole == "HOSPITAL_ADMIN"
        ) {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
        } else if (
          userRole == "SERVICELINE_ADMIN" ||
          userRole == "PHYSICIAN"
        ) {
          thisController.state.selectedHealthSystemId =
            thisController.userDetails["healthSystemId"];
          thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
          thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
        } else {
          thisController.state.selectedHealthSystemId =
            localStorage.getItem("healthSystemId");
          thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
        }
        thisController.setState(thisController.state);
        thisController.fetchHealthSystemDetails();
        var thisController = this;
        var serviceLinesLoadedPromise = thisController.fetchServiceLines();
        var fetchLastNDaysPromise = thisController.fetchLastNDays();
        var proceduresLoadedPromise = thisController.fetchProcedures();
        var physicianLoadPromise = thisController.fetchPhysicians();
        Promise.all([
          serviceLinesLoadedPromise,
          fetchLastNDaysPromise,
          proceduresLoadedPromise,
          physicianLoadPromise,
        ]).then(() => {
          // thisController.fetchManageAdmissionDetails();
          thisController.fetchRiskAdmissions();
          thisController.setState(thisController.state);
        });
        this.onActiveClick = this.onActiveClick.bind(this);
      }
    } else {
      thisController.state.selectedHealthSystemId =
        localStorage.getItem("healthSystemId");
      thisController.state.selectedHospitalId =
        localStorage.getItem("hospitalId");
      localStorage.setItem("admissions-nav-bar-selection", "manage-admission");

      var userRole = thisController.userDetails["userRole"];
      if (userRole == "HEALTHSYSTEM_ADMIN") {
        thisController.state.selectedHealthSystemId =
          thisController.userDetails["healthSystemId"];
        thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
      } else if (
        userRole == "HOSPITAL_ADMIN"
      ) {
        thisController.state.selectedHealthSystemId =
          thisController.userDetails["healthSystemId"];
        thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
      } else if (
        userRole == "SERVICELINE_ADMIN" ||
        userRole == "PHYSICIAN"
      ) {
        thisController.state.selectedHealthSystemId =
          thisController.userDetails["healthSystemId"];
        thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
        thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
      } else {
        thisController.state.selectedHealthSystemId =
          localStorage.getItem("healthSystemId");
        thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
      }
      thisController.setState(thisController.state);
      thisController.fetchHealthSystemDetails();
      var thisController = this;
      var serviceLinesLoadedPromise = thisController.fetchServiceLines();
      var fetchLastNDaysPromise = thisController.fetchLastNDays();
      var proceduresLoadedPromise = thisController.fetchProcedures();
      var physicianLoadPromise = thisController.fetchPhysicians();
      Promise.all([
        serviceLinesLoadedPromise,
        fetchLastNDaysPromise,
        proceduresLoadedPromise,
        physicianLoadPromise,
      ]).then(() => {
        // thisController.fetchManageAdmissionDetails();
        thisController.fetchRiskAdmissions();
        thisController.setState(thisController.state);
      });
      this.onActiveClick = this.onActiveClick.bind(this);
    }


  }

  componentWillUnmount() {
    if (localStorage.getItem("enteredLastNDays")) {
      localStorage.removeItem("enteredLastNDays");
      localStorage.removeItem("riskStatusStartDate");
      localStorage.removeItem("riskStatusEndDate");
    }

  }


  fetchRiskForProviderPatients = () => {
    var thisController = this;

    thisController.state.selectedHealthSystemId =
      localStorage.getItem("healthSystemId");
    thisController.state.selectedHospitalId =
      localStorage.getItem("hospitalId");
    localStorage.setItem("admissions-nav-bar-selection", "manage-admission");

    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
    } else {
      thisController.state.selectedHealthSystemId =
        localStorage.getItem("healthSystemId");
      thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
    }
    thisController.setState(thisController.state);
    thisController.fetchHealthSystemDetails();
    var thisController = this;
    var serviceLinesLoadedPromise = thisController.fetchServiceLines();
    var fetchLastNDaysPromise = thisController.fetchLastNDays();
    var proceduresLoadedPromise = thisController.fetchProcedures();
    var physicianLoadPromise = thisController.fetchPhysicians();
    Promise.all([
      serviceLinesLoadedPromise,
      fetchLastNDaysPromise,
      proceduresLoadedPromise,
      physicianLoadPromise,
    ]).then(() => {
      // thisController.fetchManageAdmissionDetails();
      thisController.fetchRiskAdmissions();
      thisController.setState(thisController.state);
    });
  }

  fetchRiskForAllPatientsInServiceLine = () => {
    var thisController = this;

    thisController.state.selectedHealthSystemId =
      localStorage.getItem("healthSystemId");
    thisController.state.selectedHospitalId =
      localStorage.getItem("hospitalId");
    localStorage.setItem("admissions-nav-bar-selection", "manage-admission");

    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
    } else {
      thisController.state.selectedHealthSystemId =
        localStorage.getItem("healthSystemId");
      thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
    }
    thisController.setState(thisController.state);
    thisController.fetchHealthSystemDetails();
    var thisController = this;
    var serviceLinesLoadedPromise = thisController.fetchServiceLines();
    var fetchLastNDaysPromise = thisController.fetchLastNDays();
    var proceduresLoadedPromise = thisController.fetchProcedures();
    var physicianLoadPromise = thisController.fetchPhysicians();
    Promise.all([
      serviceLinesLoadedPromise,
      fetchLastNDaysPromise,
      proceduresLoadedPromise,
      physicianLoadPromise,
    ]).then(() => {
      thisController.fetchRiskAdmissionsForServiceLine();
      thisController.setState(thisController.state);
    });
  }


  fetchRiskForAllPatientsInHospital = () => {
    var thisController = this;

    thisController.state.selectedHealthSystemId =
      localStorage.getItem("healthSystemId");
    thisController.state.selectedHospitalId =
      localStorage.getItem("hospitalId");
    localStorage.setItem("admissions-nav-bar-selection", "manage-admission");

    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
    } else {
      thisController.state.selectedHealthSystemId =
        localStorage.getItem("healthSystemId");
      thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
    }
    thisController.setState(thisController.state);
    thisController.fetchHealthSystemDetails();
    var thisController = this;
    var serviceLinesLoadedPromise = thisController.fetchServiceLines();
    var fetchLastNDaysPromise = thisController.fetchLastNDays();
    var proceduresLoadedPromise = thisController.fetchProcedures();
    var physicianLoadPromise = thisController.fetchPhysicians();
    Promise.all([
      serviceLinesLoadedPromise,
      fetchLastNDaysPromise,
      proceduresLoadedPromise,
      physicianLoadPromise,
    ]).then(() => {
      thisController.fetchRiskForAllPatientsInHospital();
      thisController.setState(thisController.state);
    });
  }


  notifyFailedLoad(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  notifyImproperDate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Given date seems to be a past date. Please provide a valid
        Treatment Date
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyNoTilesFilteredData(category) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;No records found for the {category} risk patients category. Displaying all available data instead.
      </b>,
      {
        position: "top-center",
      }
    );
  }


  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no patients present. </p>
    </div>
  );

  fetchPhysicians = () => {
    var treatmentId = localStorage.getItem("selectedTreatmentId");
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    console.log(
      "The selected Treatment Id for physician is: " +
      thisController.state.selectedTreatmentId
    );

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    }

    var data = {
      role: "PHYSICIAN",
      healthSystemId: thisController.state.selectedHealthSystemId,
      hospitalId: thisController.state.selectedHospitalId,
    };

    if (treatmentId) {
      data.procedureId = treatmentId;
    }

    if (!treatmentId) {
      return;
    }
    var physicianLoadPromise = new Promise((resolve, reject) => {
      $.ajax({
        url: "/my-jeeva-api/physicians",

        method: "GET",
        data: {
          procedureId: treatmentId
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },

        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var provider = res.result;
            console.log(provider);
            var noOfProviders = provider.length;
            thisController.physicianVar = [];

            var physiciansByServiceLine = [];
            for (var i = 0; i < noOfProviders; i++) {
              thisController.physicianVar.push(provider[i]);
              if (!physiciansByServiceLine[provider[i].serviceLineId]) {
                physiciansByServiceLine[provider[i].serviceLineId] = [];
              }
              physiciansByServiceLine[provider[i].serviceLineId].push(
                provider[i]
              );
            }
            thisController.physiciansByServiceLine = physiciansByServiceLine;
            if (resolve) {
              resolve();
            }
          } else {
            if (reject) {
              reject();
            }
            // thisController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (reject) {
            reject();
          }
          if (xhr.status == 401) {
            window.location.href = "/my-jeeva-api/login";
          }
        },
      });
    });

    return physicianLoadPromise;
  };

  fetchProcedures = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var providerId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = thisController.userDetails["hospitalId"];
      providerId = thisController.userDetails["userId"];
    }
    if (userRole == "PHYSICIAN") {
      $.ajax({
        url: "/my-jeeva-api/procedure-treatment",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          providerId: providerId,
          hospitalId: this.state.selectedHospitalId
        },
        success: function (res) {
          if (res.success === true) {
            // thisController.state.data = res.result;
            thisController.state.disabled = false;
            thisController.state.showLoader = true;

            var procedures = res.result;
            procedures = procedures.filter(procedure => !procedure.isDeactivated);
            console.log(procedures);
            var noOfProcedures = procedures.length;
            thisController.procedureVar = [];
            var proceduresByServiceLine = [];
            for (var i = 0; i < noOfProcedures; i++) {
              thisController.procedureVar.push(procedures[i]);
              if (!proceduresByServiceLine[procedures[i].serviceLineId]) {
                proceduresByServiceLine[procedures[i].serviceLineId] = [];
              }
              proceduresByServiceLine[procedures[i].serviceLineId].push(
                procedures[i]
              );
            }
            thisController.proceduresByServiceLine = proceduresByServiceLine;
            // }
            thisController.setState(thisController.state);
          } else {
            // thisController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            tokenVerification();
          }
        },
      });
    }
    else {
      var fetchProcedurePromise = new Promise((resolve, reject) => {
        $.ajax({
          url: "/my-jeeva-api/fetch-procedure-enrollments",

          method: "GET",
          data: {
            healthSystemId: thisController.state.selectedHealthSystemId,
            hospitalId: thisController.state.selectedHospitalId,
          },

          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          success: function (res) {
            if (res.success === true) {
              thisController.state.showLoader = true;
              thisController.setState(thisController.state);
              var procedures = res.result;
              procedures = procedures.filter(procedure => !procedure.isDeactivated);
              console.log(procedures);
              var noOfProcedures = procedures.length;
              thisController.procedureVar = [];
              var proceduresByServiceLine = [];

              for (var i = 0; i < noOfProcedures; i++) {
                thisController.procedureVar.push(procedures[i]);

                if (!proceduresByServiceLine[procedures[i].serviceLineId]) {
                  proceduresByServiceLine[procedures[i].serviceLineId] = [];
                }
                proceduresByServiceLine[procedures[i].serviceLineId].push(
                  procedures[i]
                );
              }
              thisController.proceduresByServiceLine = proceduresByServiceLine;
              console.log(
                "Sorted Treatments into these buckets: " + proceduresByServiceLine
              );
              if (resolve) {
                resolve();
              }
            } else {
              if (reject) {
                reject();
              }
              // thisController.notifyError(res.result);
            }
          },
          error: function (xhr) {
            if (reject) {
              reject();
            }
            if (xhr.status == 401) {
              window.location.href = "/my-jeeva-api/login";
            }
          },
        });
      });
      return fetchProcedurePromise;
    }

  };

  fetchServiceLines = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
    }
    if (thisController.state.selectedHospitalId == null || thisController.state.selectedHospitalId == "null") {
      thisController.state.selectedHospitalId = "00000000-0000-0000-0000-000000000000";
      thisController.setState(thisController.state);
    }
    var serviceLineFetchPromise = new Promise((resolve, reject) => {
      $.ajax({
        url: "/my-jeeva-api/service-line",

        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          healthSystemId: thisController.state.selectedHealthSystemId,
          hospitalId: thisController.state.selectedHospitalId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var serviceLine = res.result;
            var noOfServiceLine = serviceLine.length;
            thisController.serviceLineVar = [];
            for (var i = 0; i < noOfServiceLine; i++) {
              thisController.serviceLineVar[i] = serviceLine[i];
            }
            resolve();

          } else {
            if (reject) {
              reject();
            }
            // thisController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          var errorMessage = xhr.status + ": " + xhr.statusText;
          if (xhr.status == 401) {
            tokenVerification();
          }
          if (reject) {
            reject();
          }
        },
      });
    });

    return serviceLineFetchPromise;
  };



  fetchLastNDays = () => {
    var thisController = this;
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/my-jeeva-api/fetch-user-dashboard-settings",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.state.lastNDaysData = res.result;
            thisController.setState(thisController.state);

            const pastTenDays = new Date();
            pastTenDays.setDate(pastTenDays.getDate() - 10);
            const fromDate = thisController.state.fromDate;

            let patientRiskNDays = res.result.patientRiskNDays;
            if (patientRiskNDays) {
              const endDate = new Date();
              const startDate = new Date();
              startDate.setDate(endDate.getDate() - patientRiskNDays);
              startDate.setHours(0, 0, 0, 0);
              endDate.setHours(23, 59, 59, 999);

              thisController.state.enteredLastNDays = patientRiskNDays;
              thisController.state.fromDate = startDate;
              thisController.state.toDate = endDate;
              thisController.setState(thisController.state);
            } else if (
              fromDate.getDate() === pastTenDays.getDate() &&
              fromDate.getMonth() === pastTenDays.getMonth() &&
              fromDate.getFullYear() === pastTenDays.getFullYear()
            ) {
              thisController.state.enteredLastNDays = "10";
              thisController.setState(thisController.state);
            }
            resolve();
          } else {
            const pastTenDays = new Date();
            pastTenDays.setDate(pastTenDays.getDate() - 10);
            const fromDate = thisController.state.fromDate;
            if (
              fromDate.getDate() === pastTenDays.getDate() &&
              fromDate.getMonth() === pastTenDays.getMonth() &&
              fromDate.getFullYear() === pastTenDays.getFullYear()
            ) {
              thisController.state.enteredLastNDays = "10";
              thisController.setState(this.state);
            }
            resolve();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            tokenVerification();
          }
          reject(xhr.statusText);  // Reject the promise on error
        },
      });
    });
  };


  notifyImproperName() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid name
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperDateFormat() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid date in mm/dd/yyyy format
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperTimeFormat() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please enter the time in HH:MM format
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }



  fetchRiskAdmissions = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var formattedStartDate = thisController.formatDateString(thisController.state.fromDate);
    var formattedEndDate = thisController.formatDateString(thisController.state.toDate);
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
    }
    thisController.setState(thisController.state);

    $.ajax({
      // url: "/my-jeeva-api/fetch-risk-based-admissions",
      url: "/my-jeeva-api/fetch-risk-data-admissions",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: thisController.state.selectedHealthSystemId,
        hospitalId: thisController.state.selectedHospitalId,
        serviceLineId: thisController.state.selectedServiceLineId,
        startDate: formattedStartDate,
        endDate: formattedEndDate
      },
      success: function (res) {
        if (res.success === true) {
          var userRole = thisController.userDetails["userRole"];
          var userId = thisController.userDetails["userId"]
          thisController.state.isLoading = false;
          thisController.state.noMatchingData = false;
          thisController.state.pageNum = thisController.restoredPage || 1;
          thisController.state.tableReady = true;
          thisController.setState(thisController.state);
          var admissionData = res.result;
          var numberOfAdmission = admissionData.length;
          var highRiskPatients = 0;
          var lowRiskPatients = 0;
          var mediumRiskPatients = 0;

          if (userRole == "PHYSICIAN") {
            var admissionDataBasedOnProvider = [];
            var count = 0;
            for (var i = 0; i < numberOfAdmission; i++) {
              if (userId == admissionData[i].providerId) {
                admissionDataBasedOnProvider[count] = (admissionData[i]);
                count++;
              }
            }
            if (admissionDataBasedOnProvider.length > 0) {
              var providerAdmissions = admissionDataBasedOnProvider.length;
              for (var j = 0; j < providerAdmissions; j++) {
                if (admissionDataBasedOnProvider[j].riskCategory === "HIGH") {
                  highRiskPatients++;
                } else if (admissionDataBasedOnProvider[j].riskCategory === "MODERATE") {
                  mediumRiskPatients++;
                } else {
                  lowRiskPatients++;
                }
              }
            }
            thisController.state.data = admissionDataBasedOnProvider;
            thisController.state.riskData = admissionDataBasedOnProvider;
            thisController.state.activePatients = providerAdmissions;
            thisController.state.lowRiskPatients = lowRiskPatients;
            thisController.state.mediumRiskPatients = mediumRiskPatients;
            thisController.state.highRiskPatients = highRiskPatients;
            thisController.setState(thisController.state);
          } else {
            for (var k = 0; k < numberOfAdmission; k++)
              if (admissionData[k].riskCategory === "HIGH") {
                highRiskPatients++;
              } else if (admissionData[k].riskCategory === "MODERATE") {
                mediumRiskPatients++;
              } else {
                lowRiskPatients++;
              }

            thisController.state.data = res.result;
            thisController.state.riskData = res.result
            thisController.state.activePatients = numberOfAdmission;
            thisController.state.lowRiskPatients = lowRiskPatients;
            thisController.state.mediumRiskPatients = mediumRiskPatients;
            thisController.state.highRiskPatients = highRiskPatients;
            thisController.setState(thisController.state);
          }

        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  fetchRiskAdmissionsForServiceLine = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var formattedStartDate = thisController.formatDateString(thisController.state.fromDate);
    var formattedEndDate = thisController.formatDateString(thisController.state.toDate);
    thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
    thisController.setState(thisController.state);

    $.ajax({
      // url: "/my-jeeva-api/fetch-risk-based-admissions",
      url: "/my-jeeva-api/fetch-risk-data-admissions-for-serviceline",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        serviceLineId: thisController.state.selectedServiceLineId,
        startDate: formattedStartDate,
        endDate: formattedEndDate
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.data = [];
          var userRole = thisController.userDetails["userRole"];
          var userId = thisController.userDetails["userId"]
          thisController.state.isLoading = false;
          thisController.state.noMatchingData = false;
          thisController.state.pageNum = thisController.restoredPage || 1;
          thisController.state.tableReady = true;
          thisController.setState(thisController.state);
          var admissionData = res.result;
          var numberOfAdmission = admissionData.length;
          var highRiskPatients = 0;
          var lowRiskPatients = 0;
          var mediumRiskPatients = 0;

          var admissionDataBasedOnProvider = [];
          var count = 0;
          for (var i = 0; i < numberOfAdmission; i++) {
            if (userId == admissionData[i].providerId) {
              admissionDataBasedOnProvider[count] = (admissionData[i]);
              count++;
            }
          }
          if (admissionDataBasedOnProvider.length > 0) {
            var providerAdmissions = admissionDataBasedOnProvider.length;
            for (var j = 0; j < providerAdmissions; j++) {
              if (admissionDataBasedOnProvider[j].riskCategory === "HIGH") {
                highRiskPatients++;
              } else if (admissionDataBasedOnProvider[j].riskCategory === "MODERATE") {
                mediumRiskPatients++;
              } else {
                lowRiskPatients++;
              }
            }
          }
          thisController.state.data = admissionData;
          thisController.state.riskData = admissionData;
          thisController.state.activePatients = providerAdmissions;
          thisController.state.lowRiskPatients = lowRiskPatients;
          thisController.state.mediumRiskPatients = mediumRiskPatients;
          thisController.state.highRiskPatients = highRiskPatients;
          thisController.setState(thisController.state);


        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  fetchRiskPatientsOfSelectedPhysician = (physicianId) => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var formattedStartDate = thisController.formatDateString(thisController.state.fromDate);
    var formattedEndDate = thisController.formatDateString(thisController.state.toDate);
    thisController.state.serviceLineId = thisController.userDetails["serviceLineId"];
    thisController.setState(thisController.state);

    $.ajax({
      //SAME URL USED TO FETCH FOR SELECTED PHYSCIAN AND SERVICELINE
      url: "/my-jeeva-api/fetch-risk-data-admissions-for-serviceline",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        serviceLineId: thisController.state.selectedServiceLineId,
        startDate: formattedStartDate,
        endDate: formattedEndDate
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.data = [];
          var userRole = thisController.userDetails["userRole"];
          var userId = thisController.userDetails["userId"]
          thisController.state.isLoading = false;
          thisController.state.noMatchingData = false;
          thisController.state.pageNum = thisController.restoredPage || 1;
          thisController.state.tableReady = true;
          thisController.setState(thisController.state);
          var admissionData = res.result;
          var numberOfAdmission = admissionData.length;
          var highRiskPatients = 0;
          var lowRiskPatients = 0;
          var mediumRiskPatients = 0;

          var admissionDataBasedOnProvider = [];
          var count = 0;
          for (var i = 0; i < numberOfAdmission; i++) {
            if (physicianId == admissionData[i].providerId) {
              admissionDataBasedOnProvider[count] = (admissionData[i]);
              count++;
            }
          }
          if (admissionDataBasedOnProvider.length > 0) {
            var providerAdmissions = admissionDataBasedOnProvider.length;
            for (var j = 0; j < providerAdmissions; j++) {
              if (admissionDataBasedOnProvider[j].riskCategory === "HIGH") {
                highRiskPatients++;
              } else if (admissionDataBasedOnProvider[j].riskCategory === "MODERATE") {
                mediumRiskPatients++;
              } else {
                lowRiskPatients++;
              }
            }
          }
          thisController.state.data = admissionDataBasedOnProvider;
          thisController.state.riskData = admissionDataBasedOnProvider;
          thisController.state.activePatients = providerAdmissions;
          thisController.state.lowRiskPatients = lowRiskPatients;
          thisController.state.mediumRiskPatients = mediumRiskPatients;
          thisController.state.highRiskPatients = highRiskPatients;
          thisController.setState(thisController.state);


        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  fetchRiskAdmissionsForHospital = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var formattedStartDate = thisController.formatDateString(thisController.state.fromDate);
    var formattedEndDate = thisController.formatDateString(thisController.state.toDate);
    thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    thisController.setState(thisController.state);

    $.ajax({
      // url: "/my-jeeva-api/fetch-risk-based-admissions",
      url: "/my-jeeva-api/fetch-risk-data-admissions-for-hospital",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        hospitalId: thisController.state.selectedHospitalId,
        startDate: formattedStartDate,
        endDate: formattedEndDate
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.data = [];
          var userRole = thisController.userDetails["userRole"];
          var userId = thisController.userDetails["userId"]
          thisController.state.isLoading = false;
          thisController.state.noMatchingData = false;
          thisController.state.pageNum = thisController.restoredPage || 1;
          thisController.state.tableReady = true;
          thisController.setState(thisController.state);
          var admissionData = res.result;
          var numberOfAdmission = admissionData.length;
          var highRiskPatients = 0;
          var lowRiskPatients = 0;
          var mediumRiskPatients = 0;

          var admissionDataBasedOnProvider = [];
          var count = 0;
          for (var i = 0; i < numberOfAdmission; i++) {
            if (userId == admissionData[i].providerId) {
              admissionDataBasedOnProvider[count] = (admissionData[i]);
              count++;
            }
          }
          if (admissionDataBasedOnProvider.length > 0) {
            var providerAdmissions = admissionDataBasedOnProvider.length;
            for (var j = 0; j < providerAdmissions; j++) {
              if (admissionDataBasedOnProvider[j].riskCategory === "HIGH") {
                highRiskPatients++;
              } else if (admissionDataBasedOnProvider[j].riskCategory === "MODERATE") {
                mediumRiskPatients++;
              } else {
                lowRiskPatients++;
              }
            }
          }
          thisController.state.data = admissionData;
          thisController.state.riskData = admissionData;
          thisController.state.activePatients = providerAdmissions;
          thisController.state.lowRiskPatients = lowRiskPatients;
          thisController.state.mediumRiskPatients = mediumRiskPatients;
          thisController.state.highRiskPatients = highRiskPatients;
          thisController.setState(thisController.state);



        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  formatDateString(dateString) {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = date.toLocaleDateString('en-CA', options).replace(/-/g, '/');
    return formattedDate;
  }

  refreshData = (id) => {
    var refreshContent = this;
    refreshContent.state.editedId = id;
    console.log("refreshed");
    refreshContent.setState(refreshContent.state);
    this.setState({
      tilesFilteredData: [],
      tilesFilteredriskData: [],
      riskData: [],
      disabled: false,
      data: [],
      isLoading: true
    });

    if (this.state.selectedFilter === "allDepartmentPatients") {
      this.fetchRiskAdmissionsForServiceLine();
    } else if (this.state.selectedFilter === "allHospitalPatients") {
      this.fetchRiskAdmissionsForHospital();
    } else if (this.state.physicianId !== "") {
      this.fetchRiskPatientsOfSelectedPhysician(this.state.physicianId)
    } else {
      this.fetchRiskAdmissions();
    }
    // this.fetchManageAdmissionDetails();
  };

  onPageChange = (e) => {
    this.restoredPage = e;
    this.setState({ pageNum: e });
    localStorage.setItem("lastDashBoardActivePage", e);
  };


  fetchHealthSystemDetails() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/health-system",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.healthSystemGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.healthSystemGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }

          thisController.setState(thisController.state);

          if (!thisController.state.selectedHealthSystemId) {
            var healthSystemsDropDownList = thisController.healthSystemDropDownInMARef.current
            if (healthSystemsDropDownList) {
              thisController.state.selectedHealthSystemId = healthSystemsDropDownList.value;
              thisController.state.selectedHospitalId = null;
              thisController.state.selectedServiceLineId = null;

            } else {
              thisController.state.selectedHealthSystemId = res.result[0].id;
              thisController.state.selectedHospitalId = null;
              thisController.state.selectedServiceLineId = null;

            }
          }
          thisController.setState(thisController.state);

          var selectBox = thisController.healthSystemDropDownInMARef.current;
          if (selectBox && selectBox.selectedIndex >= 0) {
            thisController.onHealthSystemChange({ target: selectBox });
          }
        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  fetchHospitalDetails() {
    var thisController = this;
    var responseData = [];
    var userRole = thisController.userDetails["userRole"];
    if (userRole != "HEALTHSYSTEM_ADMIN" && userRole != "ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.setState(thisController.state);
    } else {
      this.state.selectedHealthSystemId =
        thisController.state.selectedHealthSystemId;
      thisController.setState(thisController.state);
    }
    $.ajax({
      url: "/my-jeeva-api/hospital",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: thisController.state.selectedHealthSystemId,
      },
      success: function (res) {
        if (res.success === true) {
          // thisController.state.showLoader = true;
          // thisController.setState(thisController.state);
          // responseData = res.result;
          // var totalCount = responseData.length;
          // thisController.state.hospitalGroupValue = [];
          // for (var i = 0; i < totalCount; i++) {
          //   thisController.state.hospitalGroupValue.push({
          //     name: res.result[i].name,
          //     value: res.result[i].id,
          //   });
          // }

          // thisController.setState(thisController.state);

          // if (!thisController.state.selectedHospitalId) {
          //   if (totalCount > 0) {
          //     thisController.state.selectedHospitalId = res.result[0].id;
          //     setTimeout(() => { thisController.onHospitalChange({ target: thisController.hospitalDropDownInMARef.current }) }, 100);
          //   }
          // }
          // thisController.setState(thisController.state);
          // var serviceLinesLoadedPromise = thisController.fetchServiceLines();
          // var proceduresLoadedPromise = thisController.fetchProcedures();
          // var physicianLoadPromise = thisController.fetchPhysicians();
          // Promise.all([
          //   serviceLinesLoadedPromise,
          //   proceduresLoadedPromise,
          //   physicianLoadPromise,
          // ]).then(() => {
          //   thisController.fetchManageAdmissionDetails();
          // });
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.hospitalGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.hospitalGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }

          thisController.setState(thisController.state);

          if (!thisController.state.selectedHospitalId) {
            thisController.state.selectedServiceLineId = null;
            var hospitalsDropDownList = thisController.hospitalDropDownInMARef.current
            if (hospitalsDropDownList) {
              thisController.state.selectedHospitalId = hospitalsDropDownList.value;
              // setTimeout(() => { thisController.onHealthSystemChange({ target: thisController.healthSystemDropDownInMARef.current }) }, 100);
            } else {
              thisController.state.selectedHospitalId = res.result[0].id;
            }
          }
          thisController.setState(thisController.state);

          var selectBox = thisController.hospitalDropDownInMARef.current;
          if (selectBox && selectBox.selectedIndex >= 0) {
            thisController.onHospitalChange({ target: selectBox });
          }
        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  fetchServiceLineDetails() {
    var responseData = [];
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
    }
    if (hospitalId == "null" || hospitalId == null) {
      hospitalId = "00000000-0000-0000-0000-000000000000";
    }
    $.ajax({
      url: "/my-jeeva-api/service-line",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: healthSystemId,
        hospitalId: hospitalId,
      },
      success: function (res) {
        if (res.success === true) {

          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.serviceLineGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.serviceLineGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }

          thisController.setState(thisController.state);
          if (!thisController.state.selectedServiceLineId) {
            var serviceLineId = localStorage.getItem("serviceLineId");
            if (serviceLineId && serviceLineId !== "null") {
              thisController.state.selectedServiceLineId = localStorage.getItem("serviceLineId");
            } else if (totalCount > 0) {
              thisController.state.selectedServiceLineId = res.result[0].id;
              setTimeout(() => { thisController.onServiceLineChange({ target: thisController.seriviceLineDropDownInMARef.current }) }, 100);
            } else {
              thisController.state.selectedServiceLineId = "00000000-0000-0000-0000-000000000000";
            }
          }
          thisController.setState(thisController.state);

          var selectBox = thisController.seriviceLineDropDownInMARef.current;
          if (selectBox && selectBox.selectedIndex >= 0) {
            thisController.onServiceLineChange({ target: selectBox });
          }

          var serviceLinesLoadedPromise = thisController.fetchServiceLines();
          var proceduresLoadedPromise = thisController.fetchProcedures();
          var physicianLoadPromise = thisController.fetchPhysicians();
          Promise.all([
            serviceLinesLoadedPromise,
            proceduresLoadedPromise,
            physicianLoadPromise,
          ]).then(() => {
            // thisController.setLastNDays();
            // thisController.fetchManageAdmissionDetails();
            if (thisController.state.selectedFilter === "allDepartmentPatients") {
              thisController.fetchRiskAdmissionsForServiceLine();
            } else if (thisController.state.selectedFilter === "allHospitalPatients") {
              thisController.fetchRiskAdmissionsForHospital();
            } else if (thisController.state.physicianId !== "") {
              thisController.fetchRiskPatientsOfSelectedPhysician(thisController.state.physicianId);
            } else {
              thisController.fetchRiskAdmissions();
            }
          });

        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  onHealthSystemChange = (e) => {
    this.state.tilesFilteredData = []
    this.state.data = [];
    this.state.riskData = [];
    this.state.tilesFilteredriskData = []
    this.state.isLoading = true;
    this.setState(this.state);
    var selectBox = e.target;
    this.state.dontOverLap = true;
    localStorage.setItem("serviceName", null);
    if (this.state.selectedHealthSystemId != selectBox.value) {
      this.state.selectedHospitalId = null;
      localStorage.setItem(`hospitalName`, null);
    }
    this.state.selectedHealthSystemId = selectBox.value;
    localStorage.setItem("healthSystemId", this.state.selectedHealthSystemId);
    if (selectBox.value != "") {
      localStorage.setItem("healthSystemName", selectBox.options[selectBox.selectedIndex].innerText);
    }
    this.setState(this.state);
    window.reportsNavBarController.paintPatientAdmissionHeading();
    this.fetchHospitalDetails();
  };

  onHospitalChange = (e) => {
    this.state.tilesFilteredData = []
    this.state.data = [];
    this.state.riskData = [];
    this.state.tilesFilteredriskData = []
    this.state.isLoading = true;
    this.setState(this.state);
    localStorage.setItem("serviceName", null);
    localStorage.setItem("serviceLineId", null);
    var selectBox = e.target;
    if (this.state.selectedHospitalId != selectBox.value) {
      this.state.selectedServiceLineId = null;
      localStorage.setItem(`hospitalName`, null);
    }
    this.state.selectedHospitalId = selectBox.value;
    localStorage.setItem("hospitalId", this.state.selectedHospitalId);
    if (selectBox.value != "") {
      localStorage.setItem("hospitalName", selectBox.options[selectBox.selectedIndex].innerText);
    }
    this.setState(this.state);
    window.reportsNavBarController.paintPatientAdmissionHeading();

    var thisController = this;
    thisController.fetchServiceLineDetails();
    // var serviceLinesLoadedPromise = thisController.fetchServiceLines();
    // var proceduresLoadedPromise = thisController.fetchProcedures();
    // var physicianLoadPromise = thisController.fetchPhysicians();

    // Promise.all([
    //   serviceLinesLoadedPromise,
    //   proceduresLoadedPromise,
    //   physicianLoadPromise,
    // ]).then(() => {
    //   thisController.fetchManageAdmissionDetails();
    // });
  };

  onServiceLineChange = (e) => {
    this.state.tilesFilteredData = []
    this.state.data = [];
    this.state.riskData = [];
    this.state.tilesFilteredriskData = []
    this.state.isLoading = true;
    this.setState(this.state);
    var selectBox = e.target;
    if (this.state.selectedServiceLineId != selectBox.value) {
      localStorage.setItem(`serviceLineName`, null);
    }
    this.state.selectedServiceLineId = selectBox.value;
    localStorage.setItem("serviceLineId", this.state.selectedServiceLineId);
    if (selectBox.value != "") {
      localStorage.setItem("serviceLineName", selectBox.options[selectBox.selectedIndex].innerText);
    }
    this.setState(this.state);
    // window.admissionsNavBarController.paintPatientAdmissionHeading();

    var thisController = this;

    var serviceLinesLoadedPromise = thisController.fetchServiceLines();
    var proceduresLoadedPromise = thisController.fetchProcedures();
    // var physicianLoadPromise = thisController.fetchPhysicians();

    Promise.all([
      serviceLinesLoadedPromise,
      proceduresLoadedPromise,
      // physicianLoadPromise,
    ]).then(() => {
      // thisController.fetchManageAdmissionDetails();
      // thisController.setLastNDays();
      if (thisController.state.selectedFilter === "allDepartmentPatients") {
        thisController.fetchRiskAdmissionsForServiceLine();
      } else if (thisController.state.selectedFilter === "allHospitalPatients") {
        thisController.fetchRiskAdmissionsForHospital();
      } else if (thisController.state.physicianId !== "") {
        thisController.fetchRiskPatientsOfSelectedPhysician(thisController.state.physicianId)
      } else {
        thisController.fetchRiskAdmissions();
      }
    });
  };


  showPatientDetails = (row, e) => {
    localStorage.setItem("selectedTreatmentId", row.procedureId);
    localStorage.setItem("patientProcedureId", row.procedureId);
    localStorage.setItem("patientId", row.patientId);
    localStorage.setItem("patientAddmissionId", row.id);
    localStorage.setItem("activeTabOnLoad", "schedule");
    this.setState({
      showPatientDetailsPopUp: true,
      patientId: row.patientId,
      isActive: "schedule",
    });
    this.props.history.push("/projectmgmt/patient-admission/manage-admission");
  };
  onActiveClick(active) {
    this.setState({ onActive: active });
  }

  qrCodeHandleChange = (row) => {
    this.state.patientId = row.patientId;
    this.setState(this.state);
  };
  handleChangeAdmissionTime = (e) => {
    this.state.admissionTime = e.target.value;
    this.setState(this.state);
  };
  closePatientDataPopUp = () => {
    this.setState({ showPatientDetailsPopUp: false, isActive: "schedule" });
    localStorage.setItem("last-project-manage-tab", "episodes");
    // this.refreshData();
    this.props.history.push({
      pathname: "/projectmgmt/patient-admission",
    });
  };
  closeQrCodePage = () => {
    this.setState({ showQrCode: false });
  };

  onTreatmentDateChange = (date) => {
    var onTreatmentDate = new Date(date);
    var todayDate = new Date();
    if (onTreatmentDate < todayDate) {
      this.notifyImproperDate();
    } else {
      this.state.selectedTreatmentDate = onTreatmentDate;
      this.setState(this.state);
    }

  };



  showPatientJournal = (row, e) => {
    localStorage.setItem("admissionId", row.patientAdmissionId);
    localStorage.setItem("patientProcedureId", row.treatmentId);
    localStorage.setItem("journalPatientName", row.patientName);
    this.props.history.push({
      pathname: "/projectmgmt/view-patient-journal-status",
    });
  }
  setbackgroundColor = (patientRisk) => {
    var backgroundColor;
    if (patientRisk === "LOW") {
      backgroundColor = "#90EE90";
    } else if (patientRisk === "HIGH") {
      backgroundColor = "#FF474C";
    } else if (patientRisk === "MODERATE") {
      backgroundColor = "#fcff78"
    } else {
      backgroundColor = "#90EE90";
    }
    return backgroundColor;
  }
  handleFromDateChange = (date) => {
    const { toDate } = this.state;
    date.setHours(0, 0, 0, 0);

    if (date <= toDate) {
      this.state.tilesFilteredData = [];
      this.state.riskData = [];
      this.state.tilesFilteredriskData = []
      this.state.data = [];
      this.state.isLoading = true;
      this.state.fromDate = date;
      this.state.enteredLastNDays = "";
      this.setState(this.state);
      // this.fetchManageAdmissionDetails();
      if (this.state.selectedFilter === "allDepartmentPatients") {
        this.fetchRiskAdmissionsForServiceLine();
      } else if (this.state.selectedFilter === "allHospitalPatients") {
        this.fetchRiskAdmissionsForHospital();
      } else if (this.state.physicianId !== "") {
        this.fetchRiskPatientsOfSelectedPhysician(this.state.physicianId)
      } else {
        this.fetchRiskAdmissions();
      }
    } else {
      this.notifyImproperFromDateSelection()
    }

  };

  handleToDateChange = (date) => {
    const { fromDate } = this.state;
    const dateformat = new Date(date);
    dateformat.setHours(23, 59, 59, 999);
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    if (dateformat >= fromDate && dateformat <= today) {
      this.state.tilesFilteredData = [];
      this.state.riskData = [];
      this.state.tilesFilteredriskData = []
      this.state.data = [];
      this.state.isLoading = true;
      this.state.toDate = dateformat;
      this.state.enteredLastNDays = "";
      this.setState(this.state);
      // this.fetchManageAdmissionDetails();
      if (this.state.selectedFilter === "allDepartmentPatients") {
        this.fetchRiskAdmissionsForServiceLine();
      } else if (this.state.selectedFilter === "allHospitalPatients") {
        this.fetchRiskAdmissionsForHospital();
      } else if (this.state.physicianId !== "") {
        this.fetchRiskPatientsOfSelectedPhysician(this.state.physicianId)
      } else {
        this.fetchRiskAdmissions();
      }
    } else if (dateformat < fromDate) {
      this.notifyImproperToDateSelection("to");
    } else if (dateformat > today) {
      this.notifyImproperToDateSelection("today");
    }
  };

  notifyImproperFromDateSelection() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;From date should be less than To Date.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  improperDaysInput() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please enter a number less than 1000.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperToDateSelection(message) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;{message === "to" ? "To date should be greater than From Date." : "To date cannot be greater than today's date."}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  handleAnchor = (row) => {
    const fromDate = new Date(this.state.fromDate);
    const toDate = new Date(this.state.toDate);

    const differenceInMs = Math.abs(toDate - fromDate);

    const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);
    localStorage.setItem("differenceInDays", differenceInDays);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastDashBoardActivePage", pageToSave);


    if (differenceInDays > 10) {
      localStorage.setItem("startDate", this.state.fromDate);
      localStorage.setItem("endDate", this.state.toDate);
      localStorage.setItem("entryEndDate", toDate);
      localStorage.setItem("entryStartDate", fromDate);
    } else {
      localStorage.setItem("startDate", "");
      localStorage.setItem("endDate", "");
      const resultDate = new Date(toDate);
      resultDate.setDate(toDate.getDate() - 10);
      localStorage.setItem("entryEndDate", toDate);
      localStorage.setItem("entryStartDate", resultDate);
    }

    localStorage.setItem('patientAdmissionId', row.patientAdmissionId);
    if (row.breachedParentRuleIds !== null) {
      localStorage.setItem("parentRuleId", row.breachedParentRuleIds)
    }
    localStorage.setItem('patientName', row.patientName);
    localStorage.setItem('treatmentIdForDashBoard', row.treatmentId);
    localStorage.setItem("patientId", row.patientId);
    localStorage.setItem("riskLevel", row.riskCategory);
    localStorage.setItem("procedureName", row.treatmentName);
    if (row.breachedRuleSetNames !== null) {
      localStorage.setItem("breachedRuleSetNames", row.breachedRuleSetNames);
    } else {
      localStorage.setItem("breachedRuleSetNames", "-");
    }

    localStorage.setItem("selectedNdays", this.state.enteredLastNDays);
    localStorage.setItem("startingDate", this.state.fromDate);
    localStorage.setItem("endingDate", this.state.toDate);
    this.props.history.push({
      pathname: "/projectmgmt/reports/patient-dashboard",
    });
  }

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    if (rowA[field] != null && rowB[field] != null) {
      var a = rowA[field].toLowerCase();
      var b = rowB[field].toLowerCase();
    }

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };




  getColoumns() {
    var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Patient Risk Level</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('riskCategory'),
        selector: (row) => {
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "2px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              overflow: "hidden",
            }}
          >
            {row.riskCategory}
          </div>
          return (
            <div className="container-fluid" style={{ textAlign: "left", background: this.setbackgroundColor(row.riskCategory) }}>
              {row.riskCategory ? row.riskCategory : ""}
            </div>
          );
        },
      },

      {
        name: <b style={{ fontSize: "16px" }}>Patient Name</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('patientName'),
        selector: (row) => (
          <Link to={row.id == "" || row.id == this.state.editedId ? "javascript:void(0)" : "/projectmgmt/reports/patient-dashboard"}>
            <div name="name"
              onClick={() => row.id == "" || row.id == this.state.editedId ? "" : this.handleAnchor(row)}
            >
              {row.patientName}
            </div>
          </Link>

        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Triggered Rules</b>,
        // sortable: true,
        // sortFunction: this.caseInsensitiveSort('userName'),
        selector: (row) => (
          <div name="name"
          // onClick={() => row.id == "" || row.id == this.state.editedId ? "" : this.handleAnchor(row)}
          >
            {row.breachedRuleSetNames ? row.breachedRuleSetNames : row.breachedRuleSetName}
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Treatment Name</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('treatmentName'),
        selector: (row) => {
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "2px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              overflow: "hidden",
            }}
          >
            {row.treatmentName}
          </div>
          return (
            <div className="container-fluid" style={{ textAlign: "left" }}>
              {row.treatmentName ? row.treatmentName : ""}
            </div>
          );
        },
      },

      {
        name: <b style={{ fontSize: "16px" }}>Provider Name</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('providerName'),
        selector: (row) => {
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "2px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              overflow: "hidden",
            }}
          >
            {row.providerName}
          </div>
          return (
            <div className="container-fluid" style={{ textAlign: "left" }}>
              {row.providerName}
            </div>
          );
        },
      },

      {
        name: (
          <div Align="center">
            <b style={{ fontSize: "16px" }}>Action</b>
          </div>
        ),
        selector: (row) => (
          <div id="action" Align="">
            <div
              className="row"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >

              <div >
                <button
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    padding: "2px",
                    width: "3vw",
                    margin: "0.5vw",
                  }}
                  title="view results"
                >
                  <img
                    className="img-responsive"
                    src={"./assets/images/eye.png"}
                    style={{
                      marginTop: "6px",
                      backgroundColor: "#282a65",
                      borderRadius: "5px",
                      padding: "3px",
                      height: "3.5vh"
                    }}
                    // onClick={(e) =>
                    //   this.showPatientJournal(row, e)
                    // }
                    onClick={() => row.id == "" || row.id == this.state.editedId ? "" : this.handleAnchor(row)}

                  />
                </button>
              </div>

            </div>
          </div>
        ),
      },
    ];

    return columns;
  }

  getOverviewRiskColoumn = () => {
    return [
      {
        name: 'Category',
        selector: 'category',
        sortable: true,
      },
      {
        name: 'Count',
        selector: 'count',
        sortable: true,
      },
    ];
  };

  patientRiskData = () => {
    const { activePatients, lowRiskPatients, mediumRiskPatients, highRiskPatients } = this.state;

    const data = [
      { category: 'Active Patients', count: activePatients, riskLevel: 'active' },
      { category: 'High Risk Patients', count: highRiskPatients, riskLevel: 'high' },
      { category: 'Moderate Risk Patients', count: mediumRiskPatients, riskLevel: 'medium' },
      { category: 'Low Risk Patients', count: lowRiskPatients, riskLevel: 'low' },

    ];

    return data;
  };

  conditionalRowStyles = [
    {
      when: row => row.riskLevel === 'active',
      style: {
        backgroundColor: 'lightblue',
      },
    },
    {
      when: row => row.riskLevel === 'low',
      style: {
        backgroundColor: '#90EE90',
      },
    },
    {
      when: row => row.riskLevel === 'medium',
      style: {
        backgroundColor: '#FFFFED',
      },
    },
    {
      when: row => row.riskLevel === 'high',
      style: {
        backgroundColor: '#FF474C',
      },
    },
  ];

  // handleSearch = (event) => {

  //   var thisController = this;
  //   thisController.state.searchTerm = event.target.value;
  //   thisController.setState(thisController.state);
  //   if (thisController.state.searchTerm == undefined || thisController.state.searchTerm === "" || thisController.state.searchTerm === null) {
  //     thisController.state.searchTerm = "";
  //     thisController.state.tilesFilteredData = [];
  //     thisController.state.isLoading = true;
  //     thisController.state.searchIcon = true;
  //     thisController.state.data = [];
  //     thisController.setState(thisController.state);
  //     thisController.fetchManageAdmissionDetails();
  //   } else {
  //     // thisController.state.searchTerm = thisController.state.searchTerm;
  //     thisController.state.searchIcon = false;

  //     var searchData = {
  //       searchTerm: thisController.state.searchTerm,
  //       riskData: thisController.state.data
  //     }
  //     thisController.state.isLoading = true;
  //     thisController.state.data = [];
  //     thisController.setState(thisController.state);
  //     $.ajax({
  //       url: "/my-jeeva-api/search-risk-based-admissions",
  //       method: "POST",
  //       contentType: "application/json",
  //       data:
  //         JSON.stringify(searchData),
  //       headers: {
  //         Authorization: "Bearer " + localStorage.getItem("access_token"),
  //       },
  //       success: function (res) {
  //         if (res.success === true) {
  //           if (res.result.length > 0) {
  //             thisController.state.data = [];
  //             thisController.state.noMatchingData = false;
  //             thisController.setState(thisController.state);
  //             thisController.state.data = res.result;
  //             thisController.state.isLoading = false;
  //             thisController.setState(thisController.state);
  //           } else {
  //             thisController.state.noMatchingData = true;
  //             thisController.state.isLoading = false;
  //             thisController.setState(thisController.state);
  //           }
  //         }
  //       },
  //       error: function (xhr) {
  //       },
  //     });
  //   }
  // };


  handleSearch = (event) => {
    var thisController = this;
    thisController.state.searchTerm = event.target.value;
    thisController.setState(thisController.state);
    // var riskData = thisController.state.tilesFilteredriskData.length > 0 ? thisController.state.tilesFilteredriskData : thisController.state.riskData;

    if (thisController.state.debounceTimeout) {
      clearTimeout(thisController.state.debounceTimeout);
    }

    var userRole = thisController.userDetails["userRole"];
    var formattedStartDate = thisController.formatDateString(thisController.state.fromDate);
    var formattedEndDate = thisController.formatDateString(thisController.state.toDate);
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
    }
    thisController.setState(thisController.state);

    var debounceTimeout = setTimeout(function () {
      if (!thisController.state.searchTerm || thisController.state.searchTerm.trim() === "") {
        thisController.setState({
          searchTerm: "",
          tilesFilteredData: [],
          isLoading: true,
          searchIcon: true,
          data: []
        });
        if (thisController.state.selectedFilter === "allDepartmentPatients") {
          thisController.fetchRiskAdmissionsForServiceLine();
        } else if (thisController.state.selectedFilter === "allHospitalPatients") {
          thisController.fetchRiskAdmissionsForHospital();
        } else if (thisController.state.physicianId !== "") {
          thisController.fetchRiskPatientsOfSelectedPhysician(thisController.state.physicianId)
        } else {
          thisController.fetchRiskAdmissions();
        }
      } else {
        thisController.setState({
          searchTerm: thisController.state.searchTerm,
          searchIcon: false,
          isLoading: true,
          data: [],
          tilesFilteredData: []
        });

        // var searchData = {
        //   searchTerm: thisController.state.searchTerm,
        //   riskData: riskData
        // };

        $.ajax({
          url: "/my-jeeva-api/search-risk-based-admissions",
          method: "POST",
          // contentType: "application/json",
          data: {
            healthSystemId: thisController.state.selectedHealthSystemId,
            hospitalId: thisController.state.selectedHospitalId,
            serviceLineId: thisController.state.selectedServiceLineId,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            searchTerm: thisController.state.searchTerm
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          success: function (res) {
            if (res.success === true) {
              if (res.result.length > 0) {
                thisController.setState({
                  data: res.result,
                  tilesFilteredData: thisController.state.tilesFilteredData.length > 0 ? res.result : [], // Update tilesFilteredData only if it was being searched
                  noMatchingData: false,
                  isLoading: false
                });
              } else {
                thisController.setState({
                  noMatchingData: true,
                  isLoading: false
                });
              }
            }
          },
          error: function (xhr) {
            thisController.setState({
              isLoading: false
            });
          }
        });
      }
    }, 500);
    thisController.setState({ debounceTimeout: debounceTimeout });
  };


  setLastNDays = (e) => {
    var thisController = this;
    thisController.state.enteredLastNDays = e.target.value;
    thisController.setState(thisController.state);
    var days = e.target.value;

    if (thisController.state.lastNDaysDebounceTimeout) {
      clearTimeout(thisController.state.lastNDaysDebounceTimeout);
    }

    var lastNDaysDebounceTimeout = setTimeout(function () {
      if (days < 1000) {
        let id = thisController.userDetails["userId"];
        let name = thisController.userDetails["name"];
        var toDate = new Date();
        var fromDate = new Date();
        if (days == "") {
          fromDate.setDate(toDate.getDate() - 1);
        } else {
          fromDate.setDate(toDate.getDate() - days);
        }
        thisController.state.isLoading = true;
        thisController.state.tilesFilteredData = [];
        thisController.state.data = [];
        thisController.state.tilesFilteredriskData = [];
        thisController.state.riskData = []
        thisController.setState(thisController.state);
        let userData = {
          userId: id,
          userName: name,
          patientRiskNDays: days == "" ? 0 : days,
        }
        $.ajax({
          url: "/my-jeeva-api/manage-user-dashboard-settings",
          method: "POST",
          contentType: "application/json",
          data:
            JSON.stringify(userData),
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          success: function (res) {
            if (res.success === true) {
              var LastNDaysPromise = thisController.fetchLastNDays();
              console.log(
                thisController.state.lastNDaysData.id
                  ? "The user N days is updated"
                  : "The user N days is added"
              );
              Promise.all([
                LastNDaysPromise
              ]).then(() => {
                // thisController.fetchManageAdmissionDetails();
                if (thisController.state.selectedFilter === "allDepartmentPatients") {
                  thisController.fetchRiskAdmissionsForServiceLine();
                } else if (thisController.state.selectedFilter === "allHospitalPatients") {
                  thisController.fetchRiskAdmissionsForHospital();
                } else if (thisController.state.physicianId !== "") {
                  thisController.fetchRiskPatientsOfSelectedPhysician(thisController.state.physicianId);
                } else {
                  thisController.fetchRiskAdmissions();
                }
              })
            } else {
              thisController.state.fromDate = fromDate;
              thisController.state.toDate = toDate;
              // thisController.state.enteredLastNDays = days;
              thisController.setState(thisController.state);
              // thisController.fetchManageAdmissionDetails();
              if (thisController.state.selectedFilter === "allDepartmentPatients") {
                thisController.fetchRiskAdmissionsForServiceLine();
              } else if (thisController.state.selectedFilter === "allHospitalPatients") {
                thisController.fetchRiskAdmissionsForHospital();
              } else if (thisController.state.physicianId !== "") {
                thisController.fetchRiskPatientsOfSelectedPhysician(thisController.state.physicianId)
              } else {
                thisController.fetchRiskAdmissions();
              }
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              tokenVerification();
            }
          },
        });

      } else {
        thisController.improperDaysInput();
      }
    }, 500);
    thisController.setState({ lastNDaysDebounceTimeout: lastNDaysDebounceTimeout });
  };

  filterBasedOnDashBoard = (category) => {
    var thisController = this;
    var dashboardData = thisController.state.data;
    thisController.state.tilesFilteredData = [];
    thisController.state.isLoading = false;
    thisController.setState(thisController.state);
    if (category == "high") {
      for (var index = 0; index < dashboardData.length; index++) {
        if (dashboardData[index].riskCategory === "HIGH") {
          thisController.state.tilesFilteredData.push(dashboardData[index])
        }
      }
    } else if (category == "medium") {
      for (var index = 0; index < dashboardData.length; index++) {
        if (dashboardData[index].riskCategory === "MODERATE") {
          thisController.state.tilesFilteredData.push(dashboardData[index])
        }
      }
    } else if (category == "low") {
      for (var index = 0; index < dashboardData.length; index++) {
        if (dashboardData[index].riskCategory === "LOW") {
          thisController.state.tilesFilteredData.push(dashboardData[index])
        }
      }
    } else {
      thisController.state.data = dashboardData;
    }
    this.setState(this.state);
    if (thisController.state.tilesFilteredData.length === 0 && (category !== "active")) {
      if (category == "medium") {
        thisController.notifyNoTilesFilteredData("moderate");
      } else {
        thisController.notifyNoTilesFilteredData(category);
      }
    }
  }

  // filterOptionChange = (event) => {
  //   var thisController = this;
  //   var targetValue = event.target.value;
  //   if (targetValue === "myPatients") {
  //     thisController.fetchRiskForProviderPatients();
  //   } else if (targetValue === "allHospitalPatients") {
  //     thisController.fetchRiskAdmissionsForHospital();
  //   } else if (targetValue === "allDepartmentPatients") {
  //     thisController.fetchRiskForAllPatientsInServiceLine();

  //   }
  //   thisController.setState({ selectedFilter: event.target.value, physicianId: "" });
  // };

  addAllOptionIfMissing = (callback) => {
    const { allPhysicians } = this.state;
    const alreadyExists = allPhysicians.some(
      (physician) => physician.userName === "All"
    );

    if (!alreadyExists) {
      this.setState(
        {
          allPhysicians: [{ id: "00000", userName: "All" }, ...allPhysicians],
        },
        callback
      );
    } else {
      callback();
    }
  };

  filterOptionChange = (event) => {
    const targetValue = event.target.value;

    if (targetValue === "myPatients") {
      this.fetchRiskForProviderPatients();
      var providerId = this.userDetails.userId
      localStorage.setItem("last-used-dropdown", "mine")
      this.setState({ selectedFilter: targetValue, selectedPhysicianId: providerId });
    } else if (targetValue === "allHospitalPatients") {
      this.addAllOptionIfMissing(() => {
        this.fetchRiskAdmissionsForHospital();
        localStorage.setItem("last-used-dropdown", "myHospital")
        this.setState({ selectedFilter: targetValue, selectedPhysicianId: "00000" });
      });
    } else if (targetValue === "allDepartmentPatients") {
      this.addAllOptionIfMissing(() => {
        this.fetchRiskForAllPatientsInServiceLine();
        localStorage.setItem("last-used-dropdown", "myDepartment")
        this.setState({ selectedFilter: targetValue, selectedPhysicianId: "00000" });
      });
    } else {
      this.setState({ selectedFilter: targetValue, selectedPhysicianId: "" });
    }
  };


  physicianOptionChange = (event) => {
    const thisController = this;
    const targetValue = event.target.value;
    var providerId = thisController.userDetails.userId

    // const updatedPhysicians = thisController.state.allPhysicians.filter(
    //   (physician) => physician.userName !== "All"
    // );

    if (targetValue === "00000") {
      thisController.setState({
        selectedFilter: "allDepartmentPatients",
        // allPhysicians: updatedPhysicians,
        selectedPhysicianId: targetValue
      }
      )
    }
    if (targetValue === providerId) {
      thisController.setState({
        selectedFilter: "myPatients",
        // allPhysicians: updatedPhysicians,
        selectedPhysicianId: targetValue
      },
        () => {
          thisController.riskPatientsOfSelectedPhysician(targetValue);
        }
      )
    } else {
      thisController.setState(
        {
          // allPhysicians: updatedPhysicians,
          selectedPhysicianId: targetValue,
          // selectedFilter: "",
        },
        () => {
          thisController.riskPatientsOfSelectedPhysician(targetValue);
        }
      );
    }

  };



  // fetchRiskPatientsOfSelectedPhysician = (physicianId) => {
  //   var thisController = this;
  //   thisController.state.data = [];
  //   thisController.setState(thisController.state);
  //   $.ajax({
  //     url: "/my-jeeva-api/fetch-patients-for-selected-physician",
  //     method: "GET",
  //     data: {
  //       physicianId: physicianId
  //     },
  //     headers: {
  //       Authorization: "Bearer " + localStorage.getItem("access_token"),
  //     },
  //     success: function (res) {
  //       if (res.success === true) {
  //         if (res.result.length > 0) {
  //           thisController.state.data = [];
  //           thisController.state.noMatchingData = false;
  //           thisController.setState(thisController.state);
  //           thisController.state.data = res.result;
  //           thisController.state.isLoading = false;
  //           thisController.setState(thisController.state);
  //         } else {
  //           thisController.state.noMatchingData = true;
  //           thisController.state.isLoading = false;
  //           thisController.setState(thisController.state);
  //         }
  //       }
  //     },
  //     error: function (xhr) {

  //     },
  //   });

  // };


  fetchAllPhysicians() {
    var fetchDataContoller = this;
    var lastUsedDropdown = localStorage.getItem("last-used-dropdown");

    $.ajax({
      url: "/my-jeeva-api/all-physicians-in-department",
      method: "GET",
      data: {
        hospitalId: fetchDataContoller.userDetails["hospitalId"]
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var physiansList = res.result;
          for (var j = 0; j < physiansList.length; j++) {
            if (physiansList[j].id === fetchDataContoller.userDetails["userId"]) {
              fetchDataContoller.state.allPhysicians.unshift(physiansList[j]);
            } else {
              fetchDataContoller.state.allPhysicians.push(physiansList[j]);
            }
          } if (res.result.length > 0) {
            if (lastUsedDropdown === "myHospital") {
              fetchDataContoller.state.allPhysicians.unshift({ id: "00000", userName: "All" });
            } else if (lastUsedDropdown === "myDepartment") {
              fetchDataContoller.state.allPhysicians.unshift({ id: "00000", userName: "All" });
            } else {
              fetchDataContoller.state.allPhysicians.push({ id: "00000", userName: "All" });
            }
          }
          fetchDataContoller.setState(fetchDataContoller.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva-api/login";
        }
      },
    });
  }

  riskPatientsOfSelectedPhysician = (physicianId) => {
    var thisController = this;

    thisController.state.selectedHealthSystemId =
      localStorage.getItem("healthSystemId");
    thisController.state.selectedHospitalId =
      localStorage.getItem("hospitalId");
    localStorage.setItem("admissions-nav-bar-selection", "manage-admission");

    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
    } else {
      thisController.state.selectedHealthSystemId =
        localStorage.getItem("healthSystemId");
      thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
    }
    thisController.setState(thisController.state);
    thisController.fetchHealthSystemDetails();
    var thisController = this;
    var serviceLinesLoadedPromise = thisController.fetchServiceLines();
    var fetchLastNDaysPromise = thisController.fetchLastNDays();
    var proceduresLoadedPromise = thisController.fetchProcedures();
    var physicianLoadPromise = thisController.fetchPhysicians();
    Promise.all([
      serviceLinesLoadedPromise,
      fetchLastNDaysPromise,
      proceduresLoadedPromise,
      physicianLoadPromise,
    ]).then(() => {
      thisController.fetchRiskPatientsOfSelectedPhysician(physicianId);
      thisController.setState(thisController.state);
    });
  }

  clearSearchData = () => {
    const thisController = this;
    thisController.setState({ searchTerm: "" }, () => {
      const lastUsedDropdown = localStorage.getItem("last-used-dropdown");
  
      if (thisController.userDetails.userRole === "PHYSICIAN") {
        if (lastUsedDropdown === "mine") {
          thisController.fetchRiskAdmissions();
        } else if (lastUsedDropdown === "myHospital") {
          thisController.fetchRiskAdmissionsForHospital();
        } else if (lastUsedDropdown === "myDepartment") {
          thisController.fetchRiskAdmissionsForServiceLine();
        } else if (lastUsedDropdown === null) {
          thisController.fetchRiskAdmissions();
        } else {
          thisController.fetchRiskAdmissions();
          thisController.setState(thisController.state);
        }
      } else {
        thisController.fetchRiskAdmissions();
      }
    });
  };


render() {
  const patientFilterOptions = [
    { value: "myPatients", label: "Only my patients" },
    { value: "allDepartmentPatients", label: "All patients in my department" },
    { value: "allHospitalPatients", label: "All patients in my hospital" },
  ];

  const loginProvider = [
    { value: this.userDetails["userId"], label: this.userDetails["name"] }
  ]

  let defaultActiveTab = "schedule";
  const { data } = this.state;
  var lastUsedDropdown = localStorage.getItem("last-used-dropdown");
  if (lastUsedDropdown === "myHospital") {
    lastUsedDropdown = "allHospitalPatients"
  } else if (lastUsedDropdown === "myDepartment") {
    lastUsedDropdown = "allDepartmentPatients"
  } else if (lastUsedDropdown === "mine") {
    lastUsedDropdown = "myPatients"
  }

  var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
  var patientRiskData = this.patientRiskData();

  if (lastUsedDropdown) {
    const index = patientFilterOptions.findIndex(option => option.value === lastUsedDropdown);

    if (index !== -1) {
      const [matchedOption] = patientFilterOptions.splice(index, 1);
      patientFilterOptions.unshift(matchedOption);
    }
  }

  return (
    <div style={{ marginRight: "1%" }} id="manageAdmissionTab">
      <div
        style={{
          background: "#F9F9FB",
          display: this.state.showLoader ? "block" : "none",
        }}
      >
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        <link rel="stylesheet" href="assets/css/styles.css" />

        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        <link
          rel="shortcut icon"
          type="image/png"
          href="assets/images/bot.ico"
        />
        <title> Dheeyantra | BackEnd Api </title>
        <link
          rel="stylesheet"
          href="plugins/font-awesome/css/font-awesome.min.css"
        />
        <link rel="stylesheet" href="assets/css/custom-style.css" />
        <link rel="stylesheet" href="assets/css/toggleButton.css" />
        <link
          rel="stylesheet"
          href="assets/css/React_Table_CSS/react-table.css"
        />
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/images/edit.svg" rel="stylesheet" />
        <link href="assets/images/add.svg" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        <link href="assets/css/menu-drop-down.css" rel="stylesheet" />
        <link
          href="StyleSheet.css"
          rel="stylesheet"
          type="text/css"
          media="only screen"
        />
        <link
          href="MobileStyleSheet.css"
          rel="stylesheet"
          type="text/css"
          media="only screen and (max-device-width: 480px) , only screen and (-webkit-min-device-pixel-ratio: 2) , screen and (-webkit-device-pixel-ratio:1.5)"
        />
        <link
          rel="shortcut icon"
          type="image/png"
          href="assets/images/bot.ico"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="//netdna.bootstrapcdn.com/bootstrap/3.1.1/css/bootstrap.min.css"
        />
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        <link href="assets/css/menu-items.css" rel="stylesheet" />
        <link href="assets/css/horizantal-line.css" rel="stylesheet" />
        <link rel="stylesheet" href="assets/css/adminlte.css" />
        <link
          href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
          rel="stylesheet"
        />
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        <link rel="stylesheet" href="assets/css/drop-down-alignment.css" />
        <link rel="stylesheet" href="plugins/select2/css/select2.min.css" />
        <link rel="stylesheet" href="assets/css/select2.min.css" />
        <link rel="stylesheet" href="assets/css/flaticon.css" />
        <link rel="stylesheet" href="assets/css/index.css" />
        <link rel="stylesheet" href="assets/css/modal-style.css" />
        <link href="assets/css/material.css" rel="stylesheet" />
        <link href="assets/css/bootstrap.min.css" rel="stylesheet" />
        <link href="react-table-without-pagination.css" rel="stylesheet" />
        <link href="assets/css/div-as-input-field.css" rel="stylesheet" />
        <div className="row" style={{ marginLeft: "15px" }}>
          <div className="col-sm-4" style={{ marginTop: "2px" }}></div>
        </div>

        <div className="row" style={{ marginLeft: "14px" }}>
          {/* <div className="col-sm-2">
              <h6
                className="nav-item"
                style={{ color: "#282a65", marginTop: "1vh" }}
              >
                Risk Dashboard
              </h6>
            </div> */}
          <div
            className="modal"
            style={{
              display: this.state.showPatientDetailsPopUp ? "flex" : "none",
              justifyContent: "center", alignItems: "center"
            }}
          >
            <div className="modal-dialog" id="center-aligned-account-modal" style={{ marginTop: "-12rem", marginLeft: "15rem" }} >
              <div
                className="modal-content"
                style={{
                  // position: "absolute",
                  marginTop: "37vh",
                  marginLeft: "7vh",
                  transform: "translate(7%, -7%)",
                  height: "auto",
                  width: "60vw",
                  overflowY: "scroll"
                }}
                Align="center"
              >
                <div className="modal-header noBorder">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    id="close_id"
                    onClick={() => this.closePatientDataPopUp()}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </button>
                </div>
                <div className="modal-body">
                  <ManageTabSettings
                    data={this.state.patientId}
                    isActive={defaultActiveTab}
                    onActiveClick={this.onActiveClick}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal"
            style={{ display: this.state.showQrCode ? "block" : "none" }}
          >
            <div
              className="modal-dialog"
              id="center-aligned-account-modal"
              style={{ marginTop: "-13vh" }}
            >
              <div
                className="modal-content"
                style={{
                  height: "auto",
                  marginTop: "10vw",
                  width: "33vw",
                  marginLeft: "19vw",
                }}
                Align="center"
              >
                <div className="modal-header noBorder">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    id="close_id"
                    onClick={this.closeQrCodePage}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </button>
                </div>
                <div className="modal-body">
                  <h5 Align="center">On-boarding QR</h5>
                  <form ref={(el) => (this.myFormRef = el)}>
                    <a
                      href={
                        "https://www.myjeeva.net/?token=" + this.state.patientId
                      }
                      target="_blank"
                    >
                      <img
                        id="qr_code"
                        src={this.state.qrCode}
                        style={{
                          width: "21vw",
                          marginLeft: "-1vw",
                          height: "21vw",
                        }}
                      />
                    </a>
                  </form>
                  <p>
                    <b>Note: </b>Please open your My JEEVA app and scan the
                    On-boarding QR
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-8"
            Align="right"
          // style={{ display: "flex", alignItems: "center" }}
          >
            <label
              style={{
                display:
                  window.SCOPE_VALUE.CURRENT >
                    window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                    ? "inline"
                    : "none",
              }}
            >
              Health System
            </label>

            <select
              value={this.state.selectedHealthSystemId}
              id="healthSystemId"
              className="healthSystem"
              onChange={(e) => this.onHealthSystemChange(e)}
              placeholder="Select Health System"
              ref={this.healthSystemDropDownInMARef}
              style={{
                display:
                  window.SCOPE_VALUE.CURRENT >
                    window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                    ? "inline"
                    : "none",
                height: "30px",
                borderRadius: "4px",
                backgroundColor: "#F9F9FB",
                width: "13vw",
                marginLeft: "10px",
              }}
            >
              {this.state.healthSystemGroupValue.map((healthSystem) => (
                <option value={healthSystem.value}>
                  {healthSystem.name}
                </option>
              ))}
            </select>
            <label
              style={{
                marginLeft: "3vh",
                display:
                  window.SCOPE_VALUE.CURRENT >
                    window.SCOPE_VALUE.HOSPITAL_ADMIN
                    ? "inline"
                    : "none",
              }}
            >
              Hospital
            </label>

            <select
              value={this.state.selectedHospitalId}
              id="hospitalDropDown"
              className="hospital"
              onChange={(e) => this.onHospitalChange(e)}
              placeholder="Select hospital"
              ref={this.hospitalDropDownInMARef}
              style={{
                display:
                  window.SCOPE_VALUE.CURRENT >
                    window.SCOPE_VALUE.HOSPITAL_ADMIN
                    ? "inline"
                    : "none",
                height: "30px",
                borderRadius: "4px",
                backgroundColor: "#F9F9FB",
                width: "13vw",
                marginLeft: "10px",
              }}
            >
              {this.state.hospitalGroupValue.map((hospitalGroup) => (
                <option value={hospitalGroup.value}>
                  {hospitalGroup.name}
                </option>
              ))}
            </select>
            <label
              style={{
                marginLeft: "3vh",
                display:
                  window.SCOPE_VALUE.CURRENT >
                    window.SCOPE_VALUE.SERVICELINE_ADMIN
                    ? "inline"
                    : "none",
              }}
            >
              Service Line
            </label>
            <select
              value={this.state.selectedServiceLineId}
              id="serviceLine"
              className="hospital"
              onChange={(e) => this.onServiceLineChange(e)}
              placeholder="Select serviceline"
              ref={this.seriviceLineDropDownInMARef}
              style={{
                display:
                  window.SCOPE_VALUE.CURRENT >
                    window.SCOPE_VALUE.SERVICELINE_ADMIN
                    ? "inline"
                    : "none",
                height: "30px",
                borderRadius: "4px",
                backgroundColor: "#F9F9FB",
                width: "13vw",
                marginLeft: "10px",
              }}
            >
              {this.state.serviceLineGroupValue.map((serviceLineGroup) => (
                <option value={serviceLineGroup.value}>
                  {serviceLineGroup.name}
                </option>
              ))}
            </select>


            {/* <div className="p-2" style={{
                marginBottom: "10px", marginLeft: "40px",
                marginRight: "-10vw", marginTop: "-6vh"
              }}>

                <button
                  title="Refresh"
                  onClick={this.refreshData}
                  type="button"
                  className="btn action-button"
                >
                  <img src="./assets/images/refresh_white_24dp.png"></img>
                </button>
              </div> */}
          </div>
        </div>

        <div className="row" style={{
          marginLeft: "9vw", marginTop:
            userRole == "PHYSICIAN" || userRole == "SERVICELINE_ADMIN"
              ? "-3vh"
              : "1.6vh",
        }}
        >
          <span style={{ marginLeft: "-5vw", display: "flex", alignItems: "center", marginTop: "1.7vh" }}>Last
            <input
              type="number"
              id="days"
              onChange={(e) => this.setLastNDays(e)}
              // value={localStorage.getItem("enteredLastNDays") ? localStorage.getItem("enteredLastNDays")
              //   : this.state.enteredLastNDays}
              value={this.state.enteredLastNDays === "" ? "" : this.state.enteredLastNDays}
              placeholder="Custom"
              style={{
                padding: "5px",
                width: "3vw",
                border: "2px solid #777676",
                borderRadius: "10px",
                margin: "2px 5px 2px 5px",
                height: "2.5vh"
              }}
            />
            days
          </span>
          <div style={{ width: "77vw", paddingLeft: "2vw", display: "flex" }}>
            <div style={{ width: "20vw" }}>
              <label style={{ marginRight: "12px", marginTop: "20px" }}>From</label>
              <DatePicker
                id="fromDate"
                selected={this.state.fromDate}
                onChange={this.handleFromDateChange}
                autoOk={true}
                placeholderText="From Date"
                className="form-control"
                dateFormat="MM/dd/yyyy"
              />
            </div>
            <div style={{ width: "20vw" }}>
              <label style={{ marginRight: "12px", marginTop: "20px" }}>To</label>
              <DatePicker
                selected={this.state.toDate}
                id="toDate"
                onChange={this.handleToDateChange}
                autoOk={true}
                placeholderText="To Date"
                className="form-control"
                dateFormat="MM/dd/yyyy"
              />
            </div>
          </div>
          {/* <span style={{ marginLeft: "-5vw", display: "flex", alignItems: "center" }}>Last
              <input
                type="number"
                id="days"
                onChange={(e) => this.setLastNDays(e)}
                value={localStorage.getItem("enteredLastNDays") ? localStorage.getItem("enteredLastNDays")
                  : this.state.enteredLastNDays}
                style={{
                  padding: "5px",
                  width: "3vw",
                  border: "2px solid #777676",
                  borderRadius: "10px",
                  margin: "2px 5px 2px 5px",
                  height: "2.5vh"
                }}
              />
              days
            </span> */}

          {/* <button className="btn action-button" style={{marginLeft:"-5vw"}}
              onClick={() => this.setLastNDays(10)}>Last 10 Days</button>
            <button className="btn action-button" style={{marginLeft:"2vw"}}
              onClick={() => this.setLastNDays(30)}>Last 30 Days</button> */}

          {/* <input type="text"
              style={{
                width: "12vw",
                border: "2px solid #777676",
                borderRadius: "10px",
                padding: "10px",
                height: "0.7vw",
                marginTop: "1vh",
                marginLeft: "5vw"
              }}
              value={this.state.searchTerm}
              onChange={this.handleSearch}
              placeholder="Search..."
              id="searching"
            /> */}
        </div>

        <div
          className="row"
          style={{ marginLeft: "15px" }}
        >
          <div className="col-lg-12 ">
            <div style={{ display: "flex", alignItems: "end", justifyContent: "space-between", }}>
              <div className="dashboard">
                {patientRiskData.map((item, index) => (
                  <div key={index} className={`tile ${item.riskLevel}`} style={{ cursor: "pointer" }}
                    onClick={() => this.filterBasedOnDashBoard(item.riskLevel)}
                  >
                    <div style={{ fontSize: "15px" }}>
                      {item.category}
                    </div>
                    <div style={{ fontSize: "30px", textAlign: "right" }}>
                      {item.count}
                    </div>
                  </div>
                ))}
              </div>

              <div>
                <label
                  style={{
                    marginLeft: "-50vh",
                    display:
                      window.SCOPE_VALUE.CURRENT <
                        window.SCOPE_VALUE.SERVICELINE_ADMIN
                        ? "inline"
                        : "none",
                  }}
                >
                  View Options
                </label>
                <select
                  // value={this.state.selectedServiceLineId}
                  value={this.state.selectedFilter}
                  id="serviceLine"
                  className="hospital"
                  onChange={(e) => this.filterOptionChange(e)}
                  placeholder="Select option"
                  // ref={this.seriviceLineDropDownInMARef}
                  style={{
                    display:
                      window.SCOPE_VALUE.CURRENT <
                        window.SCOPE_VALUE.SERVICELINE_ADMIN
                        ? "inline"
                        : "none",
                    height: "30px",
                    borderRadius: "4px",
                    backgroundColor: "#F9F9FB",
                    width: "13vw",
                    marginLeft: "10px",
                  }}
                >
                  {

                    patientFilterOptions.map((filter) => (
                      <option key={filter.value} value={filter.value}>
                        {filter.label}
                      </option>
                    ))
                  }

                </select>
                <label
                  style={{
                    marginLeft: "3vh",
                    display:
                      window.SCOPE_VALUE.CURRENT <
                        window.SCOPE_VALUE.SERVICELINE_ADMIN
                        ? "inline"
                        : "none",
                  }}
                >
                  Providers
                </label>
                {lastUsedDropdown === null || lastUsedDropdown === "mine" ||
                  // this.state.selectedFilter === "" ||
                  this.state.selectedFilter === "myPatients" ?
                  <select
                    id="physicianId"
                    className="hospital"
                    value={this.state.selectedPhysicianId}
                    onChange={(e) => this.physicianOptionChange(e)}
                    placeholder="Select option"
                    style={{
                      display:
                        window.SCOPE_VALUE.CURRENT <
                          window.SCOPE_VALUE.SERVICELINE_ADMIN
                          ? "inline"
                          : "none",
                      height: "30px",
                      borderRadius: "4px",
                      backgroundColor: "#F9F9FB",
                      width: "13vw",
                      marginLeft: "10px",
                    }}
                  >
                    {
                      loginProvider.map((provider) =>
                        <option key={provider.value} value={provider.value}>
                          {provider.label}
                        </option>
                      )
                    }
                  </select>
                  :
                  <select
                    id="physicianId"
                    className="hospital"
                    value={this.state.selectedPhysicianId}
                    onChange={(e) => this.physicianOptionChange(e)}
                    placeholder="Select option"
                    style={{
                      display:
                        window.SCOPE_VALUE.CURRENT <
                          window.SCOPE_VALUE.SERVICELINE_ADMIN
                          ? "inline"
                          : "none",
                      height: "30px",
                      borderRadius: "4px",
                      backgroundColor: "#F9F9FB",
                      width: "13vw",
                      marginLeft: "10px",
                    }}
                  >
                    {
                      this.state.allPhysicians.map((physician) => {
                        return (
                          (this.state.selectedFilter === "allHospitalPatients" ||
                            lastUsedDropdown === "allHospitalPatients") ? (
                            <option key={physician.id} value={physician.id}>
                              {physician.userName}
                            </option>
                          ) : (
                            (this.userDetails["serviceLineId"] === physician.serviceLineId || physician.id === "00000") && (
                              <option key={physician.id} value={physician.id}>
                                {physician.userName}
                              </option>
                            )
                          )
                        );
                      })
                    }

                  </select>

                }

                {/* <img
                    className="img-responsive"
                    src="./assets/images/search.svg"
                    style={{
                      position: "relative",
                      top: "4vh",
                      // left: "30vw",
                      padding: "0.5vh",
                      display: this.state.searchIcon ? "block" : "none"
                    }}
                  /> */}
                <input type="text"
                  // style={{
                  //   width: "11vw",
                  //   border: "2px solid #777676",
                  //   borderRadius: "10px",
                  //   padding: this.state.searchIcon ? "10px 10px 10px 24px" : "10px",
                  //   height: "0.7vw",
                  //   // marginLeft: "30vw"
                  // }}

                  style={{
                    width: "10vw",
                    border: "1px solid #777676",
                    borderRadius: "3px",
                    // padding: this.state.searchIcon ? "10px 10px 10px 24px" : "10px",
                    padding: "10px",
                    height: "0.6vw",
                    paddingRight: "2rem",
                  }}
                  value={this.state.searchTerm}
                  onChange={this.handleSearch}
                  placeholder="Search..."
                  id="searching"
                />
                {this.state.searchTerm && (
                  <span
                    onClick={() => this.clearSearchData()}
                    style={{
                      // position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#777676",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                      lineHeight: 1,
                      userSelect: "none",
                      marginLeft: "-1vw"
                    }}
                  >
                    ×
                  </span>
                )}
              </div>
            </div>
            {!this.state.noMatchingData && <div
              className="card"
              style={{ marginTop: "25px", }}
            >
              {this.state.isLoading && (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  <p>Loading ...</p>
                </div>
              )}
              {(!this.state.isLoading && this.state.data.length === 0 && this.state.tilesFilteredData.length === 0) && (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  <p>There are no admission records to display </p>
                </div>
              )}
              {((this.state.data.length > 0 || this.state.tilesFilteredData.length > 0) && (!this.state.noMatchingData)) && (
                <DataTable
                  data={this.state.tilesFilteredData.length > 0 ? this.state.tilesFilteredData : this.state.data}
                  key={"table-" + this.state.pageNum}
                  columns={this.getColoumns()}
                  fixedHeaderScrollHeight="400px"
                  pagination={this.state.paginationValue}
                  defaultPageSize={5}
                  pageSizeOptions={[5, 10, 15]}
                  onChangePage={this.onPageChange}
                  paginationDefaultPage={this.state.pageNum || 1}
                  noDataComponent={<this.CustomNoDataComponent />}
                />
              )}
              { }

            </div>}

            <ToastContainer className="Toast-at-center" />
          </div>
        </div>
        <div className='card' style={{ marginTop: "3vh" }}>
          {this.state.noMatchingData &&
            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)", }}>
              <p>No matching options found ...</p>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
}

export default PatientRiskStatus;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientRiskStatus.js